<template>
  <div class="page">
    <dashboard-header @search-changed="searchChanged"></dashboard-header>
    
    <div class="content">
      <div class="container-fluid">
        <!-- Page title -->
        <div class="page-header">
          <div class="row align-items-center">
            <div class="col-auto">
              <h2 class="page-title">
                Client List -
                <select @change="onFilterChanged" class="" v-model="clientStatus">
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
                <router-link to="client/new" class="btn btn-primary">Create New Client</router-link>
              </h2>
              <select v-model="viewUser">
                <option value="me">My Clients</option>
                <option value="all">All Users Clients</option>
                <option v-for="user in searchableUsers" v-bind:value="user.username">{{user.firstName}} {{user.lastName}}</option>
              </select>
              
              <select v-model="perPageStr">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
        </div>
      
        <div class="row row-deck row-cards">
          <div class="col-md-12">
            <div class="card">
              
              <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                  <a :class="`nav-link ${selectedTab == 'owner' ? 'active' : ''}`" href="#nav-owner" @click.prevent="selectTab('owner')">Search By Owner</a>
                </li>
                <li class="nav-item">
                  <a :class="`nav-link ${selectedTab == 'assist' ? 'active' : ''}`" href="#nav-assist" @click.prevent="selectTab('assist')">Search By Assistant</a>
                </li>
              </ul>
              
              <paged-api-table
                v-bind:columns="clientColumns"
                v-bind:filter="clientFilter"
                v-bind:include-relations="includeRelations"
                module="Clients"
                default-sort="createdAt DESC"
                v-bind:per-page="clientPerPage"
                v-bind:show-total-count="showTotalCount">
                </paged-api-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
  import DashboardHeader from "./DashboardHeader.vue";
  import DashboardFooter from "./DashboardFooter.vue";
  import PagedApiTable from "./PagedApiTable.vue";
  import AuthToken from "../api/authtoken";
  import WebLLCRESTApi from "../api/api";
  import { Usernames } from "../util/usernames.js";
  import Cookies from "js-cookie";
  import moment from "moment";
  
  export default {
    created() {
      this.campaignApi = new WebLLCRESTApi("Campaigns", this.$router);
      
      const usersApi = new WebLLCRESTApi("Users", this.$router);
      this.users = usersApi.getData(null, {
        order: ["firstName ASC", "lastName ASC"]
      });
      
      (async () => {
        this.searchableUsers = (await this.users).filter((user) => {
          return user.role == "admin" || user.role == "account";
        });
      })();
    },
    
    data() {
      const authToken = AuthToken.getAuthObject();
      
      return {
        selectedTab: (authToken.role == "basic" ? "assist" : "owner"),
        clientStatus: "active",
        viewUser: (authToken.role == "admin" ? "all" : "me"),
        users: null,
        searchableUsers: [],
        
        clientColumns: [
          { key: "firstName", "text": "First Name", type: "String", sort: true },
          { key: "lastName", "text": "Last Name", type: "String", sort: true },
          { key: "displayName", "text": "Display Name", type: "String", sort: true },
          { key: "autoReport", "text": "Automation", type: "Boolean", sort: true },
          { key: "owner", "text": "Acct Manager", type: "String", sort: true, fnAsyncLoad: (item) => { return this.getUserFullName(item.owner) } },
          { key: "latestCampaignMonth", "text": "Campaign Age", type: "String", fnAsyncLoad: this.loadLatestCampaignMonth.bind(this) },
          { key: "startDate", "text": "Start Date", type: "String", fnAsyncLoad: this.loadLatestCampaignDate.bind(this) },
          { key: "details", "text": "Details", type: "Route", route: "/client/:id" },
          { key: "delete", "text": "Delete", type: "SoftDelete" },
        ],
        
        clientFilter: this.rebuildFilter(),
        
        txtSearch: "",
        
        clientPerPage: (Cookies.get('clientPerPage') ? parseInt(Cookies.get('clientPerPage')) : 10),
        perPageStr: (Cookies.get('clientPerPage') ? Cookies.get('clientPerPage') : "10"),
        includeRelations: [
          {
            relation: "campaigns",
            scope: {
              fields: [ "startDate", "hasEndDate", "endDate", "clientId" ]
            }
          }
        ],
        showTotalCount: true
      };
    },
    
    methods: {
      async loadLatestCampaignDate(item) {
        if(!item.latestCampaign) {
          this.loadLatestCampaignDetails(item);
        }
        
        const latestCampaign = item.latestCampaign;
        
        if(latestCampaign) {
          return moment(latestCampaign.startDate).format("MM/DD/YYYY");
        }
        else {
          return "";
        }
      },
      
      async loadLatestCampaignMonth(item) {
        if(!item.latestCampaign) {
          this.loadLatestCampaignDetails(item);
        }
        
        const latestCampaign = item.latestCampaign;
        
        if(latestCampaign) {
          const startDate = moment(latestCampaign.startDate);
          
          if(latestCampaign.hasEndDate) {
            const endDate = moment(latestCampaign.endDate);
            
            const inDate = endDate.isAfter(moment());
            
            if(inDate) {
              const campaignMonth = moment().diff(startDate.add(-3, "days"), "months");
              
              return "Month " + campaignMonth;
            }
            else {
              return "Finished";
            }
          }
          else {
            const campaignMonth = moment().diff(startDate, "months");
            
            return "∞ Month to Month " + campaignMonth;
          }
        }
        else {
          return "N/A";
        }
      },
      
      loadLatestCampaignDetails(item) {
        if(item.campaigns) {
          item.campaigns.sort((a, b) => {
            if(a.startDate < b.startDate) {
              return -1;
            }
            else if(a.startDate > b.startDate) {
              return 1;
            }
            else {
              return 0;
            }
          });
          
          item.latestCampaign = item.campaigns.length > 0 ? item.campaigns[0] : null;
        }
        else {
          item.latestCampaign = null;
        }
      },
      
      async getUserFullName(username) {
        if(!username) {
          return username;
        }
        
        const users = await this.users;
        
        for(const user of users) {
          if(user.username == username) {
            return user.firstName + " " + user.lastName;
          }
        }
        
        return username;
      },
      
      onFilterChanged() {
        this.rebuildFilter();
      },
      
      rebuildFilter() {
        const viewUser = (this.viewUser ? this.viewUser :
          (AuthToken.getAuthObject().role == "admin" ? "all" : "me"));
        
        const search = (this.txtSearch ?
              [
                { "displayName": { like: "%" + this.txtSearch + "%" } },
                { "firstName": { like: "%" + this.txtSearch + "%" } },
                { "lastName": { like: "%" + this.txtSearch + "%" } }
              ] :
              undefined);
        
        const owner = (viewUser === "all" ? undefined :
          viewUser === "me" ? AuthToken.getAuthObject().username :
          viewUser);
        
        const clientStatus = this.clientStatus ? this.clientStatus : "active";
        
        if(search) {
          this.clientFilter = {
            "or": search.map((orItem) => {
              orItem.status = clientStatus;
              orItem.deleted = false;
              return orItem;
            })
          };
        }
        else {
          const selectedTab = (this.selectedTab ? this.selectedTab : (AuthToken.getAuthObject().role == "basic" ? "assist" : "owner"));
          
          if(selectedTab == "owner") {
            this.clientFilter = {
              "owner": owner,
              "status": clientStatus,
              "deleted": false
            };
          }
          else {
            this.clientFilter = {
              "authBasicUser": owner,
              "status": clientStatus,
              "deleted": false
            };
          }
        }
        
        return this.clientFilter;
      },
      
      selectTab(newTab) {
        this.selectedTab = newTab;
        this.rebuildFilter();
      },
      
      searchChanged(newSearch) {
        this.txtSearch = newSearch;
        this.rebuildFilter();
      }
    },
    
    watch: {
      perPageStr(to, from) {
        Cookies.set("clientPerPage", to);
        this.clientPerPage = parseInt(to);
      },
      
      viewUser(to, from) {
        this.rebuildFilter();
      }
    },
    
    components: {
      DashboardHeader,
      DashboardFooter,
      PagedApiTable
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ClientsList.vue